import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var AccountCreationNotificationDialog = /*#__PURE__*/function (_Vue) {
  function AccountCreationNotificationDialog() {
    var _this;
    _classCallCheck(this, AccountCreationNotificationDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AccountCreationNotificationDialog, [].concat(args));
    _defineProperty(_this, "toggleDialog", void 0);
    _defineProperty(_this, "userFirstName", void 0);
    _defineProperty(_this, "passwordUrl", void 0);
    _defineProperty(_this, "visible", false);
    return _this;
  }
  _inherits(AccountCreationNotificationDialog, _Vue);
  return _createClass(AccountCreationNotificationDialog, [{
    key: "copyPasswordUrl",
    value: function copyPasswordUrl() {
      navigator.clipboard.writeText(this.passwordUrl);
    }
  }, {
    key: "onDialogClose",
    value: function onDialogClose() {
      this.visible = false;
      this.$emit("dialogClose");
    }
  }]);
}(Vue);
__decorate([Prop({
  default: false
})], AccountCreationNotificationDialog.prototype, "toggleDialog", void 0);
__decorate([Prop({
  default: ''
})], AccountCreationNotificationDialog.prototype, "userFirstName", void 0);
__decorate([Prop({
  default: ''
})], AccountCreationNotificationDialog.prototype, "passwordUrl", void 0);
AccountCreationNotificationDialog = __decorate([Options({
  watch: {
    toggleDialog: function toggleDialog() {
      this.visible = this.toggleDialog;
    }
  }
})], AccountCreationNotificationDialog);
export default AccountCreationNotificationDialog;